module.exports = __webpack_public_path__ + "img/contact-logo.309c44f0.png";